import React, { useEffect, useState } from 'react'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang'
import { useSelectorCustom } from '../../../components/general/general-component/abstruct-component/useSelectorCustom'
import { VariableSuppliers } from './VariableSuppliers'
import { DeleteComponent } from '../../../components/general/general-component/abstruct-component/DeleteComponent'
import { deleteSupplier, loadSupplierss } from '../../../store/Actions/ActionSuppliers'
import { ColumnSuppliers } from '../../../components/general/general-component/columns-component/ColumnSuppliers'
import SectionTopOfTable from '../../../components/general/general-component/section-top-of-table/SectionTopOfTable'
import Table2 from '../../../components/table/Table2'
import AddSupplier from './AddSupplier'
import EditSupplier from './EditSupplier'
import Warning from '../../../components/general/general-component/warning-delete/Warning'
import FilterSupplier from './FilterSupplier'
import ListMaterial from '../products/movements/ListMaterial'
import InnerLoader from '../../../components/general/inner-loader/InnerLoader'
import { UsePermissions, hasPermissions } from '../../../components/general/general-component/abstruct-component/UsePermissions'
import CheckPermissions from '../../../components/general/general-component/check-permissions'
import CheckLazyLoader from '../../../components/general/general-component/check-lazy-loader'

const Suppliers = () => {
    const { permissionss, loadingMainPermission } = UsePermissions();
    const suppliersPer = hasPermissions([{ name: "suppliers" }], permissionss);
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { suppplierss, loadingSuppplierss } = useSelectorCustom()
    const { state, setOpen, handleEdit, setopenEdit, setStateCustom, setOpenMaterial } = VariableSuppliers()
    const { stateD, warning, setdeletee, setloadDel } = DeleteComponent()
    const [suppliersArr, setsuppliersArS] = useState([])
    const [isDeleted, setIsDeleted] = useState('')
    const [idDeleted, setIdDeleted] = useState(null)
    useEffect(() => {
        if (isDeleted && idDeleted) {
            const updatedArr = [...suppliersArr];
            const indexToDelete = updatedArr.findIndex(item => item.id === idDeleted);
            if (indexToDelete !== -1) {
                updatedArr.splice(indexToDelete, 1);
                setsuppliersArS(updatedArr);
            }
        }
    }, [isDeleted, idDeleted, suppliersArr]);
    useEffect(() => {
        if (suppplierss?.length >= 0) {
            setsuppliersArS(suppplierss)
        }
    }, [suppplierss]);

    useEffect(() => {
        dispatch(loadSupplierss())
    }, []);
    const handleDelete = (id) => {
        dispatch(deleteSupplier(id, setloadDel, setIsDeleted, setIdDeleted));
    }
    const openSupplier = e => {
        e.preventDefault()
        setOpen(true)
    }
    const { columns } = ColumnSuppliers(translate, warning, handleEdit, langLocal, setOpenMaterial)
    return (
        <CheckLazyLoader>
            <CheckPermissions array={suppliersPer} loadingMainPermission={loadingMainPermission} >
                <main>
                    <FilterSupplier translate={translate} />
                    <br></br>
                    <div className="div_table margin_main shadow_main" dir={langLocal == "ar" ? "rtl" : "ltr"} style={{ position: "relative" }} >

                        {console.log(state)}
                        <div className="div_table2" dir={langLocal == "ar" ? "rtl" : "ltr"} style={{ position: "relative" }} >
                            <SectionTopOfTable langLocal={langLocal} title={translate('suppliers')} titleBtn={translate('add_suppliers')} FunctionBtn={openSupplier} />
                            {
                                loadingSuppplierss == false ? (
                                    <Table2 col={columns} roo={suppliersArr} />
                                ) : <InnerLoader />
                            }
                        </div>
                    </div>
                </main>
            </CheckPermissions>
            {
                state.open && (
                    <AddSupplier state={state} setStateCustom={setStateCustom} open={state.open} setOpen={setOpen} />
                )
            }
            {
                stateD.deletee == true ? (
                    <Warning loadDel={stateD.loadDel} arr={stateD.arrW} open={stateD.deletee} setOpen={setdeletee} handleDelete={handleDelete} />
                ) : <></>
            }
            {
                state.openEdit && (
                    <EditSupplier arr={state.arr1} open={state.openEdit} setOpen={setopenEdit} />
                )
            }
            {
                state.openMaterial && (
                    <ListMaterial open={state.openMaterial} setOpen={setOpenMaterial} />
                )
            }
        </CheckLazyLoader>
    )
}

export default Suppliers

/*

{
                state.open && (
                    <AddCategory setIsAdded={setIsAdded} state={state} setStateCustom={setStateCustom} open={state.open} setOpen={setOpen} />
                )
            }
            {
                stateD.deletee == true ? (
                    <Warning loadDel={stateD.loadDel} arr={stateD.arrW} open={stateD.deletee} setOpen={setdeletee} handleDelete={handleDelete} />
                ) : <></>
            }
            {
                state.openEdit && (
                    <EditCategory arr={state.arr1} open={state.openEdit} setOpen={setopenEdit} />
                )
            }

            */
